import { useState, useRef, useCallback, useEffect, createElement } from 'react';

var style = {"wrapper":"_1I_qj","is_type_revealTopFirst":"_2L9NA","is_type_revealBottomFirst":"_1HWL6","is_state_close":"_3OHvW","is_state_before-open-transition":"_3U8bo","is_state_close-transition":"_3FGzA","is_state_open-transition":"_RKZOX","is_state_open":"_2mqKm","is_state_before-close-transition":"_fzKDc","content":"_2jwZj"};

var assertNever = function assertNever(_) {
  throw new Error(JSON.stringify(_));
};

var forceReflow = function forceReflow(element) {
  if (!element) {
    return;
  }

  element.getBoundingClientRect();
};

var Collapsible = function Collapsible(_ref) {
  var children = _ref.children,
      open = _ref.open,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'revealBottomFirst' : _ref$type;

  var _useState = useState(open ? 'open' : 'close'),
      state = _useState[0],
      setState = _useState[1];

  var _useState2 = useState('auto'),
      contentHeight = _useState2[0],
      setContentHeight = _useState2[1];

  var contentRef = useRef(null);
  var updateContentHeight = useCallback(function () {
    if (!contentRef.current) {
      return;
    }

    var contentHeight = contentRef.current.getBoundingClientRect().height + "px";
    setContentHeight(contentHeight);
  }, []);
  var onTransitionEnd = useCallback(function (event) {
    if (event.propertyName === 'visibility') {
      setState(open ? 'open' : 'close');
    }
  }, [open]);
  useEffect(function () {
    if (state === 'close') {
      if (open) {
        updateContentHeight();
        setState('before-open-transition');
      }
    } else if (state === 'before-open-transition') {
      if (open) {
        forceReflow(contentRef.current);
        setState('open-transition');
      }
    } else if (state === 'open-transition') {
      if (!open) {
        setState('close');
      }
    } else if (state === 'open') {
      if (!open) {
        updateContentHeight();
        setState('before-close-transition');
      }
    } else if (state === 'before-close-transition') {
      if (!open) {
        forceReflow(contentRef.current);
        setState('close-transition');
      }
    } else if (state === 'close-transition') {
      if (open) {
        setState('open');
      }
    } else {
      assertNever(state);
    }
  }, [open, state, updateContentHeight]);
  return createElement("div", {
    className: style.wrapper + " " + style["is_state_" + state] + " " + style["is_type_" + type],
    style: {
      '--Collapsible-content-height': contentHeight
    },
    onTransitionEnd: onTransitionEnd,
    "aria-hidden": !open
  }, createElement("div", {
    className: style.content,
    ref: contentRef
  }, children));
};

export { Collapsible };
//# sourceMappingURL=index.modern.js.map
